import type * as Types from '../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type WhatsAppDraftPreviewQueryVariables = Types.Exact<{
  input: Types.WhatsAppDraftPreviewInput;
}>;

export type WhatsAppDraftPreviewQuery = {
  __typename?: 'Query';
  whatsAppDraftPreview: {
    __typename?: 'WhatsAppDraftPreviewResult';
    reason?: Types.WhatsAppDraftPreviewUnavailableReason | null;
    preview?: { __typename?: 'WhatsAppPreview'; headerImageUrl?: string | null; body?: string | null; ctaLabel?: string | null; ctaUrl?: string | null } | null;
  };
};

export const WhatsAppDraftPreviewDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WhatsAppDraftPreview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'WhatsAppDraftPreviewInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'whatsAppDraftPreview' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'headerImageUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'body' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ctaLabel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useWhatsAppDraftPreviewQuery__
 *
 * To run a query within a React component, call `useWhatsAppDraftPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhatsAppDraftPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhatsAppDraftPreviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWhatsAppDraftPreviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WhatsAppDraftPreviewQuery, WhatsAppDraftPreviewQueryVariables>) {
  return ApolloReactHooks.useQuery<WhatsAppDraftPreviewQuery, WhatsAppDraftPreviewQueryVariables>(WhatsAppDraftPreviewDocument, baseOptions);
}
export function useWhatsAppDraftPreviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WhatsAppDraftPreviewQuery, WhatsAppDraftPreviewQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<WhatsAppDraftPreviewQuery, WhatsAppDraftPreviewQueryVariables>(WhatsAppDraftPreviewDocument, baseOptions);
}
export type WhatsAppDraftPreviewQueryHookResult = ReturnType<typeof useWhatsAppDraftPreviewQuery>;
export type WhatsAppDraftPreviewLazyQueryHookResult = ReturnType<typeof useWhatsAppDraftPreviewLazyQuery>;
export type WhatsAppDraftPreviewQueryResult = Apollo.QueryResult<WhatsAppDraftPreviewQuery, WhatsAppDraftPreviewQueryVariables>;
